import { RootState } from '@Redux/search/store';
import { I_DepthInfo, I_FilterItem } from '@Redux/search/interfaces';
import dayjs from 'dayjs';
import { useSelector } from 'react-redux';
// import Tags from '@components/Common/Tags';
import { useEffect, useState } from 'react';

interface I_ResultConditionsParams {
    FilterItems: I_FilterItem[];
    DepthInfo?: I_DepthInfo;
    SortListBy: number;
    TagFiltersShow: string[];
    search: any
}

interface I_ResultConditionsReturn {
    ArriveID: string | null;
    GoDatestart: string;
    GoDateEnd: string;
    GroupID: string | null;
    Keywords: string | null;
    IsEnsureGroup: string | boolean | null;
    IsSold: string | boolean | null;
    ThemeID: string | null;
    DepartureID: string | null;
    WeekDay: string;
    PriceList?: any;
    AirlineIDs: string;
    TripTypes: string;
    Tags: string;
    SortType: number | null;
    Days: string;
    TravelType: any;
}

const toBoolean = (parm: string | null) => {
    if (parm == 'true') {
        return true;
    } else if (parm == 'false') {
        return false;
    } else {
        return null;
    }
};

let isSendFirst = true;

const getResultConditions = ({
    FilterItems,
    DepthInfo,
    SortListBy,
    TagFiltersShow,
    search
}: I_ResultConditionsParams): I_ResultConditionsReturn => {
    // 取得 GroupList 所需要參數
    const urlParams = new URLSearchParams(window.location.search);

    const urlObject = {
        ArriveID: urlParams.get('ArriveID'),
        GoDatestart: urlParams.get('GoDateStart') || dayjs().format('YYYY-MM-DD'),
        // GoDateEnd: urlParams.get('GoDateEnd') || dayjs().add(30, 'days').format('YYYY-MM-DD'),
        GroupID: urlParams.get('GroupID'),
        Keywords: urlParams.get('Keywords'),
        IsEnsureGroup: toBoolean(urlParams.get('IsEnsureGroup')),
        IsSold: toBoolean(urlParams.get('IsSold')),
        ThemeID: urlParams.get('ThemeID'),
        TravelPavilionGroupID: urlParams.get('TravelPavilionGroupID') || null,
        KeywordsCity: urlParams.get('KeywordsCity') || null,
        TravelType: urlParams.get('TravelType') || null,
    };

    const GoDateEnd = (() => {
        // 如果是旅遊館群，最晚出發日為多 1 年
        if (urlParams.get('TravelPavilionGroupID')) {
            return dayjs().add(3, 'year').format('YYYY-MM-DD');
        } else {
            return urlParams.get('GoDateEnd') || dayjs().add(30, 'days').format('YYYY-MM-DD');
        }
    })();
    const ConcatFilters = (type: string) =>
        FilterItems.reduce((accu: string, item: I_FilterItem) => {
            if (item.filterBy === type) {
                let accuArray = accu ? accu.split(',') : [];
                accuArray = [...accuArray, item.value.toString()];
                accu = accuArray.join();
            }
            return accu;
        }, '');

    const hasPriceCondition = !!FilterItems.some(
        (item: I_FilterItem) => item.filterBy === 'PriceRange'
    );

    const PriceCondition = (minOrMax: 'min' | 'max') =>
        FilterItems.find(
            (item: I_FilterItem) => item.filterBy === 'PriceRange' && item.subValue === minOrMax
        )?.value;

    const DepartureID = urlParams.get('DepartureID')
        ? urlParams.get('DepartureID')
        : ConcatFilters('DepartureList');

    const TravelType = (() => {
        const TravelTypeArray = FilterItems.reduce(
            (accu: number[], item: I_FilterItem): number[] => {
                return item.filterBy === 'TravelType' ? [...accu, Number(item.value)] : accu;
            },
            []
        );
        if (urlObject.TravelType !== null && isSendFirst) {
            isSendFirst = false;
            const tType = parseInt(urlObject.TravelType);
            return tType;
        }

        if (TravelTypeArray.length === 1) {
            return TravelTypeArray[0];
        }
        return 0;
    })();
    const WeekDay = ConcatFilters('WeekDays');
    const PriceList = [
        {
            PriceStart: PriceCondition('min') || DepthInfo?.PriceRange?.PriceStart || 0,
            PriceEnd: PriceCondition('max') || DepthInfo?.PriceRange?.PriceEnd || 0 || null,
        },
    ];

    if (!PriceCondition('max')) {
        PriceList.push({
            PriceStart: PriceCondition('max') || DepthInfo?.PriceRange?.PriceEnd || 0,
            PriceEnd: null,
        });
    }

    const AirlineIDs = ConcatFilters('AirlineList');
    const TripTypes = TagFiltersShow.join();
    let Tags = ConcatFilters('CategoryList');
    //直接改寫Tags
    if (search.Tags.indexOf(',') !== -1) {
        search.Tags.split(',').forEach((tag: string) => {
            if (Tags.indexOf(tag) === -1) {
                Tags += ',' + tag;
            }
        });
    } else {
        if (Tags.indexOf(search.Tags) === -1) {
            if (Tags !== '') {
                Tags += ',' + search.Tags;
            } else {
                Tags += search.Tags;
            }
        }
    }
    const Days = ConcatFilters('DayList');
    const SortType = SortListBy;

    return {
        ...urlObject,
        GoDateEnd,
        DepartureID,
        WeekDay,
        PriceList: hasPriceCondition ? PriceList : null,
        AirlineIDs,
        TripTypes,
        Tags,
        SortType,
        Days,
        TravelType,
    };
};

export default getResultConditions;
